import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable()
export class CryptoService {

  constructor(private httpClient: HttpClient) {
  }

  getClientInstances(): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/crypto-instances');
  }

  getCryptoData(cryptoId: any) {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/crypto-data/' + cryptoId);
  }
}
